<template>
  <div class="p-5 xs:p-7 sm:p-14">

    <client-only>
      <div class="w-11/12 overflow-hidden relative mb-8 mx-auto">
        <core-media-player
          src="https://forever-mars-ui.s3.amazonaws.com/video/f3/tutorial/video-editor.mp4"
        />
      </div>
    </client-only>

    <div class="flex justify-center mb-6">
      <h1 class="text-3xl font-semibold text-center">
        <span class="text-gradient-blue inline-block">Edit Your Video, Right Inside FOREVER</span>
      </h1>
    </div>

    <p class="text-lg text-center text-charcoal-400">
      Trim clips, combine moments, add title frames, and create polished videos from the memories you already have stored in your account. No downloads, no extra software — just simple editing built into your FOREVER experience.
    </p>

    <div class="mt-8 flex items-center flex-col justify-center">
      <u-button
        size="xl"
        :loading="isContinuing"
        @click="continueToEditor"
        label="Start Editing!"
        block
        class="max-w-64"
      />
    </div>

  </div>
</template>

<script setup>
  const emit = defineEmits(['continue']);

  const isContinuing = ref(false);

  async function dismissOnboarding() {
    await usePreferencesStore().updateCurrentUserPreferences({[CURRENT_USER_PREFERENCES.onbVideoEditDismissed]: true});
  }

  async function continueToEditor() {
    if (isContinuing.value) return;

    isContinuing.value = true;
    await dismissOnboarding();
    emit('continue');
  }
</script>
